import React, { useState, useEffect } from 'react';
import { Card, Table, Button, Pagination, Form, Spinner, Modal } from 'react-bootstrap';
import { Get, Put } from '@app/utils/httpProvider';
import { ACCOUNT_API, ACCOUNTINFO_API, GIAYPHEPHANHNGHE_API, CHUNGCHI_CHUYENMON_API, DANHSACH_DUYET_HOSO_API } from '@app/utils/apiUrl';
import { getUser } from '@app/utils/oidc';
import { toast } from 'react-toastify';
import { useQueryClient } from 'react-query';
import { getRoleUser } from '@app/utils/httpClient';
import { role } from '@app/utils/define';

// HÀM HỖ TRỢ HIỂN THỊ TÊN VIẾT TẮT CHO NHÃN
const getShortLoaiChungChi = (name) => {
    if (!name) return "";
    const lowerName = name.toLowerCase().trim();
    if (lowerName === "chứng chỉ kỹ thuật chuyên môn về khám bệnh, chữa bệnh") {
        return "CCKTCMKB-CB";
    }
    if (lowerName === "chứng chỉ chuyên môn kỹ thuật dưới 09 tháng" || lowerName === "chứng chỉ chuyên môn kỹ thuật dưới 9 tháng") {
        return "CCCMKT<9T";
    }
    if (lowerName === "chứng chỉ chuyên môn kỹ thuật trên 09 tháng" || lowerName === "chứng chỉ chuyên môn kỹ thuật trên 9 tháng") {
        return "CCCMKT>9T";
    }
    return name;
};

// ĐÃ SỬA: HÀM RENDER BADGE TRẠNG THÁI CHUẨN THEO MẪU THIẾT KẾ
const renderStatusBadge = (status, type = 'duyet') => {
    if (status === true) {
        return (
            <span className="badge bg-success p-2 fw-normal" style={{ fontSize: '13px', display: 'inline-flex', alignItems: 'center', minWidth: '95px', justifyContent: 'center' }}>
                <i className="fas fa-check-circle me-1"></i> {type === 'duyet' ? 'Đã duyệt' : 'Phù hợp'}
            </span>
        );
    }
    if (status === false) {
        return (
            <span className="badge bg-danger p-2 fw-normal" style={{ fontSize: '13px', display: 'inline-flex', alignItems: 'center', minWidth: '95px', justifyContent: 'center' }}>
                <i className="fas fa-times-circle me-1"></i> {type === 'duyet' ? 'Từ chối' : 'Không phù hợp'}
            </span>
        );
    }
    return (
        <span className="badge bg-secondary p-2 fw-normal" style={{ fontSize: '12px', display: 'inline-flex', alignItems: 'center', minWidth: '95px', justifyContent: 'center' }}>
            Chưa {type === 'duyet' ? 'duyệt' : 'xác nhận'}
        </span>
    );
};

// MẢNG LÝ DO TỪ CHỐI
const REJECT_REASONS = [
    { value: 'Chứng chỉ hành nghề không phù hợp', label: 'Chứng chỉ hành nghề không phù hợp' },
    { value: 'Văn bằng chứng chỉ chuyên khoa không phù hợp', label: 'Văn bằng chứng chỉ chuyên khoa không phù hợp' },
    { value: 'Khác', label: 'Khác' }
];

const DanhSachDuyetHoSo = () => {
    const [userRole, setUserRole] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [activeTab, setActiveTab] = useState('');

    const queryClient = useQueryClient();

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);

    const [hoSoModal, setHoSoModal] = useState({ show: false, itemId: null, status: null, reason: '' });
    const [rejectModal, setRejectModal] = useState({ show: false, itemId: null, reason: '', customReason: '' });

    const [danhSach, setDanhSach] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);

    const [filterXacNhan, setFilterXacNhan] = useState('all');
    const [filterDonVi, setFilterDonVi] = useState('all');
    const [filterDoiTuong, setFilterDoiTuong] = useState('all');

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const roles = await getRoleUser();

                let normalizedRoles = [];
                if (typeof roles === 'string') {
                    normalizedRoles = [roles.toLowerCase()];
                } else if (Array.isArray(roles)) {
                    normalizedRoles = roles.map(r => r.toLowerCase());
                }
                setUserRole(normalizedRoles);

                // LOGIC SET TAB MẶC ĐỊNH THEO PHÂN QUYỀN
                const checkAdmin = normalizedRoles.includes(role.Admin);
                const checkBaseAccess = normalizedRoles.includes(role.APP_DANHSACHDUYETHOSO_ACCESS);
                const checkHldt = normalizedRoles.includes(role.HLDT_NHAN_VIEN);
                const checkKhth = normalizedRoles.includes(role.PHONG_KE_HOACH_TONG_HOP);

                if (checkAdmin || (checkBaseAccess && checkHldt)) {
                    setActiveTab('thongke-hldt');
                } else if (checkBaseAccess && checkKhth) {
                    setActiveTab('thongke'); // Thống kê (Tổng quan)
                }

                const user = await getUser();
                if (!user?.profile?.sub) {
                    setIsLoading(false);
                    return;
                }

                try {
                    const resPaging = await Get(GIAYPHEPHANHNGHE_API.GET_PAGING, null, { PageIndex: currentPage, PageSize: itemsPerPage });

                    let listGiayPhepHanhNghes = resPaging?.data?.$values || resPaging?.data || resPaging || [];

                    // Bỏ qua các hồ sơ có trạng thái "Nhập liệu"
                    listGiayPhepHanhNghes = listGiayPhepHanhNghes.filter(item => {
                        const statusStr = String(item.trangThai || item.TrangThai || '').toLowerCase().trim();
                        return statusStr !== '0' && statusStr !== 'nhaplieu' && statusStr !== 'nhập liệu';
                    });

                    setTotalRecords(resPaging?.totalRecords || listGiayPhepHanhNghes.length || 0);

                    if (!listGiayPhepHanhNghes || !Array.isArray(listGiayPhepHanhNghes) || listGiayPhepHanhNghes.length === 0) {
                        setDanhSach([]);
                        return;
                    }

                    const parseTrangThai = (trangThaiValue) => {
                        if (trangThaiValue === null || trangThaiValue === undefined) return null;

                        if (typeof trangThaiValue === 'number') {
                            if (trangThaiValue === 1) return true;
                            if (trangThaiValue === 2) return false;
                            return null;
                        }

                        const text = trangThaiValue.toString().trim().toLowerCase();
                        if (text === "đã duyệt" || text === "da duyet" || text === "1") return true;
                        if (text === "từ chối" || text === "tu choi" || text === "2") return false;

                        return null;
                    };

                    const formattedData = await Promise.all(listGiayPhepHanhNghes.map(async (item) => {
                        let hoTen = "Chưa cập nhật";
                        let tenDoiTuong = "Chưa cập nhật";
                        let tenDonVi = "Chưa cập nhật";

                        if (item.accountId) {
                            const [account, doiTuongInfo] = await Promise.all([
                                Get(`${ACCOUNT_API.GET_ACCOUNT_BYID_FROM_APP_DUNGCHUNG}/${item.accountId}`),
                                Get(`${ACCOUNT_API.GET_ACCOUNT_INFO_BYID_FROM_APP_DUNGCHUNG}/${item.accountId}`)
                            ]);

                            hoTen = [account?.lastName, account?.middleName, account?.firstName]
                                .filter(Boolean)
                                .join(' ');

                            tenDoiTuong = doiTuongInfo?.doiTuong?.tenDoiTuong || tenDoiTuong;
                            tenDonVi = doiTuongInfo?.donVis?.[0]?.tenDonVi || tenDonVi;
                        }

                        const listChungChiChuyenMons = await Get(`${CHUNGCHI_CHUYENMON_API.GET_BY_ACCOUNT_INFO_ID}/${item.accountId}`);
                        const safeListCCCM = Array.isArray(listChungChiChuyenMons) ? listChungChiChuyenMons : [];

                        const cccmKHTH = safeListCCCM.map(cert => ({
                            idCccm: cert.id,
                            loaiCccm: cert.loaiChungChi || cert.tenLoaiChungChi || cert.LoaiChungChi || cert.phanLoai || "",
                            tenCccm: cert.tenChungChi || "Chưa rõ tên CC",
                            ghiChu: cert.ghiChu || cert.GhiChu || "",
                            fileUrl: cert.fileMinhChungPath || "",
                            status: parseTrangThai(cert.trangThai)
                        }));

                        const cccmHLDT = safeListCCCM.map(cert => ({
                            idCccm: cert.id,
                            loaiCccm: cert.loaiChungChi || cert.tenLoaiChungChi || cert.LoaiChungChi || cert.phanLoai || "",
                            tenCccm: cert.tenChungChi || "Chưa rõ tên CC",
                            ghiChu: cert.ghiChu || cert.GhiChu || "",
                            fileUrl: cert.fileMinhChungPath || "",
                            status: parseTrangThai(cert.trangThai)
                        }));

                        let initialXacNhanStatus = null;
                        try {
                            const duyetRes = await Get(`${DANHSACH_DUYET_HOSO_API.GET_BY_GIAYPHEP_ID}/${item.id}`);
                            const duyetData = duyetRes?.data || duyetRes;
                            const xacNhanText = duyetData?.xacNhanDuyet || duyetData?.XacNhanDuyet;

                            if (xacNhanText === "Phù hợp") {
                                initialXacNhanStatus = true;
                            } else if (xacNhanText === "Không phù hợp") {
                                initialXacNhanStatus = false;
                            }
                        } catch (error) {
                        }

                        let pvhnList = [];
                        if (Array.isArray(item.phamViHanhNgheNames) && item.phamViHanhNgheNames.length > 0) {
                            pvhnList = item.phamViHanhNgheNames;
                        } else if (Array.isArray(item.PhamViHanhNgheNames) && item.PhamViHanhNgheNames.length > 0) {
                            pvhnList = item.PhamViHanhNgheNames;
                        } else {
                            const fallbackPvhn = item.tenPhamViHanhNghe || item.TenPhamViHanhNghe || item.phamViHanhNghe || item.PhamViHanhNghe;
                            if (Array.isArray(fallbackPvhn)) {
                                pvhnList = fallbackPvhn;
                            } else if (typeof fallbackPvhn === 'string') {
                                pvhnList = [fallbackPvhn];
                            }
                        }

                        const ngayHetHanCchn = item.ngayHetHan || item.NgayHetHan || item.thoiHan || item.ThoiHan;

                        return {
                            id: item.id,
                            ten: hoTen,
                            doiTuong: tenDoiTuong,
                            donVi: tenDonVi,
                            phamViHanhNghe: pvhnList,
                            cchn: item.soGiayPhep || "Chưa cập nhật",
                            fileUrl: item.fileMinhChungPath || "",
                            moTaCchn: ngayHetHanCchn ? [`Ngày hết hạn: ${new Date(ngayHetHanCchn).toLocaleDateString('vi-VN')}`] : [],
                            cchnStatus: parseTrangThai(item.trangThai),
                            cccmHLDT: cccmHLDT,
                            cccmKHTH: cccmKHTH,
                            xacNhanStatus: initialXacNhanStatus,
                            trangThai: item.trangThaiHoSo ?? 0
                        };
                    }));

                    setDanhSach(formattedData);

                } catch (error) {
                    console.error('Lỗi khi lấy thông tin hồ sơ tổng hợp:', error);
                }
            } catch (error) {
                console.error('Không thể kết nối đến hệ thống xác thực:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [currentPage, itemsPerPage]);

    const uniqueDonVi = [...new Set(danhSach.map(item => item.donVi).filter(val => val && val !== "Chưa cập nhật"))].sort();
    const uniqueDoiTuong = [...new Set(danhSach.map(item => item.doiTuong).filter(val => val && val !== "Chưa cập nhật"))].sort();

    const filteredDanhSach = danhSach.filter(item => {
        let matchXacNhan = true;
        if (filterXacNhan !== 'all') {
            if (filterXacNhan === 'phu_hop') matchXacNhan = item.xacNhanStatus === true;
            else if (filterXacNhan === 'khong_phu_hop') matchXacNhan = item.xacNhanStatus === false;
            else if (filterXacNhan === 'chua_xac_nhan') matchXacNhan = item.xacNhanStatus === null || item.xacNhanStatus === undefined;
        }

        let matchDonVi = true;
        if (filterDonVi !== 'all') {
            matchDonVi = item.donVi === filterDonVi;
        }

        let matchDoiTuong = true;
        if (filterDoiTuong !== 'all') {
            matchDoiTuong = item.doiTuong === filterDoiTuong;
        }

        return matchXacNhan && matchDonVi && matchDoiTuong;
    });

    const currentItems = filteredDanhSach;
    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = indexOfFirstItem + currentItems.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);

    const handleItemsPerPageChange = (e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); };
    const handleFilterXacNhanChange = (e) => { setFilterXacNhan(e.target.value); setCurrentPage(1); };
    const handleFilterDonViChange = (e) => { setFilterDonVi(e.target.value); setCurrentPage(1); };
    const handleFilterDoiTuongChange = (e) => { setFilterDoiTuong(e.target.value); setCurrentPage(1); };
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleViewFile = async (fileUrl, e) => {
        e.preventDefault();
        if (!fileUrl) return;
        try {
            const BACKEND_DOMAIN = process.env.REACT_APP_API_URL || 'https://localhost:5001';
            const fullUrl = fileUrl.startsWith('http') ? fileUrl : `${BACKEND_DOMAIN}${fileUrl}`;
            window.open(fullUrl, '_blank');
        } catch (error) {
            console.error('Lỗi khi tải file đính kèm:', error);
            alert('Không thể tải file.');
        }
    };

    const executeVerifyCchn = (id, status) => {
        const updatedList = danhSach.map(item => item.id === id ? { ...item, cchnStatus: status } : item);
        setDanhSach(updatedList);
    };

    const executeVerifyCccm = (userId, cccmId, status) => {
        const updatedList = danhSach.map(user => {
            if (user.id === userId) {
                const updatedHLDT = user.cccmHLDT.map(cert => cert.idCccm === cccmId ? { ...cert, status: status } : cert);
                const updatedKHTH = user.cccmKHTH.map(cert => cert.idCccm === cccmId ? { ...cert, status: status } : cert);
                return { ...user, cccmHLDT: updatedHLDT, cccmKHTH: updatedKHTH };
            }
            return user;
        });
        setDanhSach(updatedList);
    };

    const executeXacNhanPhuHop = (id, status) => {
        const updatedList = danhSach.map(item => item.id === id ? { ...item, xacNhanStatus: status } : item);
        setDanhSach(updatedList);
    };

    const openConfirmModal = (type, itemId, certId, status) => {
        setPendingAction({ type, itemId, certId, status });
        setShowConfirmModal(true);
    };

    const handleConfirmAction = async () => {
        if (!pendingAction) return;

        const { type, itemId, certId, status } = pendingAction;
        const payload = {
            fieldName: 'TrangThai',
            value: status ? "Đã duyệt" : "Từ chối"
        };

        try {
            if (type === 'CCHN') {
                payload.id = itemId;
                await Put(`${GIAYPHEPHANHNGHE_API.UPDATE_FIELD}`, null, payload);
                executeVerifyCchn(itemId, status);
            } else if (type === 'CCCM') {
                payload.id = certId;
                await Put(`${CHUNGCHI_CHUYENMON_API.UPDATE_FIELD}`, null, payload);
                executeVerifyCccm(itemId, certId, status);
            } else if (type === 'HOSO') {
                executeXacNhanPhuHop(itemId, status);
            }

            setShowConfirmModal(false);
            setPendingAction(null);
            queryClient.invalidateQueries(['giayPhepHanhNgheProfile']);

        } catch (error) {
            console.error("Lỗi:", error);
            alert("Có lỗi xảy ra khi lưu trạng thái lên máy chủ. Vui lòng thử lại!");
        }
    };

    const getConfirmMessage = () => {
        if (!pendingAction) return '';
        const { type, status } = pendingAction;
        if (type === 'CCHN') return status ? 'Xác nhận DUYỆT chứng chỉ hành nghề này?' : 'Xác nhận KHÔNG DUYỆT chứng chỉ hành nghề này?';
        if (type === 'CCCM') return status ? 'Xác nhận DUYỆT chứng chỉ chuyên môn này?' : 'Xác nhận KHÔNG DUYỆT chứng chỉ chuyên môn này?';
        if (type === 'HOSO') return status ? 'Xác nhận toàn bộ hồ sơ này là PHÙ HỢP?' : 'Xác nhận toàn bộ hồ sơ này là KHÔNG PHÙ HỢP?';
        return 'Xác nhận?';
    };

    const xacNhanHoSoConfirm = async () => {
        if (!hoSoModal.itemId) return;
        const { itemId, status, reason } = hoSoModal;

        try {
            const duyetRes = await Get(`${DANHSACH_DUYET_HOSO_API.GET_BY_GIAYPHEP_ID}/${itemId}`);
            const duyetData = duyetRes?.data || duyetRes;

            const payload = {
                id: duyetData?.id || duyetData?.Id,
                fieldName: 'XacNhanDuyet',
                value: status ? "Phù hợp" : "Không phù hợp",
                ngayDuyet: new Date().toISOString(),
                nguoiDuyet: userRole.join(', ') || "unknown"
            };

            await Put(`${DANHSACH_DUYET_HOSO_API.UPDATE_FIELD}`, null, payload);

            if (status === false && reason) {
                await Put(`${DANHSACH_DUYET_HOSO_API.UPDATE_FIELD}`, null, { id: duyetData?.id, fieldName: 'LyDo', value: reason });
            }

            executeXacNhanPhuHop(itemId, status);
            toast.success("Xác nhận hồ sơ thành công!");
            queryClient.invalidateQueries(['giayPhepHanhNgheProfile']);

        } catch (error) {
            console.error("Lỗi:", error);
            toast.error("Không thể cập nhật. Thử lại!");
        } finally {
            setHoSoModal({ show: false, itemId: null, status: null, reason: '' });
        }
    };

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                <Spinner animation="border" variant="primary" />
                <span className="ms-2 text-muted">Đang tải dữ liệu...</span>
            </div>
        );
    }

    // LOGIC CHECK QUYỀN ĐỂ RENDER (THEO YÊU CẦU MỚI)
    const isAdmin = userRole.includes(role.Admin);
    const hasBaseAccess = userRole.includes(role.APP_DANHSACHDUYETHOSO_ACCESS);

    // Check quyền xem 2 tab của HLDT
    const canViewHLDT = isAdmin || (hasBaseAccess && userRole.includes(role.HLDT_NHAN_VIEN));

    // Check quyền xem 2 tab của KHTH
    const canViewKHTH = isAdmin || (hasBaseAccess && userRole.includes(role.PHONG_KE_HOACH_TONG_HOP));

    // Có ít nhất 1 quyền thì được vào màn hình này
    const hasAccess = isAdmin || canViewHLDT || canViewKHTH;

    if (!hasAccess) {
        return (
            <div className="container-fluid mt-5">
                <Card className="text-center p-5 shadow-sm border-0 mx-auto" style={{ maxWidth: '600px' }}>
                    <Card.Body>
                        <i className="fas fa-lock text-danger mb-3" style={{ fontSize: '4rem' }}></i>
                        <h4 className="text-danger fw-bold mt-2">Truy cập bị từ chối</h4>
                        <Button variant="outline-secondary" onClick={() => window.history.back()}>
                            <i className="fas fa-arrow-left me-2"></i> Quay lại
                        </Button>
                    </Card.Body>
                </Card>
            </div>
        );
    }

    const renderTable = (cccmField, permissions = { readOnlyCchn: false, readOnlyCccm: false, readOnlyHoSo: false }) => (
        <Table responsive hover bordered striped className="mb-0 text-center">
            <thead className="bg-light">
                <tr className="align-middle">
                    <th>STT</th>
                    <th>Họ tên</th>
                    <th>Chức danh</th>
                    <th>Đơn vị</th>
                    <th style={{ minWidth: '250px' }}>Phạm vi hành nghề</th>
                    <th style={{ minWidth: '220px' }}>Chứng chỉ hành nghề</th>
                    <th style={{ minWidth: '350px' }}>Văn bằng, chứng chỉ chuyên khoa</th>
                    <th style={{ minWidth: '100px' }}>Xác nhận phạm vi hành nghề</th>
                </tr>
            </thead>
            <tbody>
                {currentItems.length > 0 ? (
                    currentItems.map((item, index) => (
                        <tr key={item.id} className="align-middle">
                            <td className="align-middle text-center">{indexOfFirstItem + index + 1}</td>
                            <td className="text-start fw-bold align-middle">{item.ten}</td>
                            <td className="align-middle">{item.doiTuong}</td>
                            <td className="align-middle">{item.donVi}</td>

                            <td className="text-start align-middle">
                                {item.phamViHanhNghe && item.phamViHanhNghe.length > 0 ? (
                                    item.phamViHanhNghe.map((pv, idx) => (
                                        <div key={idx}>{pv}</div>
                                    ))
                                ) : (
                                    <span className="text-muted fst-italic">-</span>
                                )}
                            </td>

                            <td className="align-middle">
                                <div className="d-flex justify-content-between align-items-center text-start">
                                    <div>
                                        <div className="fw-bold mb-1">
                                            {item.fileUrl ? (
                                                <span onClick={(e) => handleViewFile(item.fileUrl, e)} title="Click để xem file" className="text-primary text-decoration-underline file-link" style={{ cursor: 'pointer' }}>
                                                    {item.cchn} <i className="fas fa-external-link-alt ms-1" style={{ fontSize: '0.8em' }}></i>
                                                </span>
                                            ) : (
                                                <span className="text-dark">{item.cchn}</span>
                                            )}
                                        </div>
                                        <div className="text-muted" style={{ fontSize: '12px' }}>
                                            {item.moTaCchn?.map((line, idx) => <div key={idx}>{line}</div>)}
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center ms-2 flex-shrink-0" style={{ gap: '4px' }}>
                                        {permissions.readOnlyCchn ? (
                                            <div>{renderStatusBadge(item.cchnStatus, 'duyet')}</div>
                                        ) : (
                                            <>
                                                <Button size="sm" variant={item.cchnStatus === true ? 'success' : 'outline-success'} onClick={() => openConfirmModal('CCHN', item.id, null, true)} title="Duyệt" className="btn-icon">
                                                    <i className="fas fa-check"></i>
                                                </Button>
                                                <Button size="sm" variant={item.cchnStatus === false ? 'danger' : 'outline-danger'} onClick={() => openConfirmModal('CCHN', item.id, null, false)} title="Từ chối" className="btn-icon">
                                                    <i className="fas fa-times"></i>
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </td>

                            <td className="align-middle">
                                {item[cccmField] && item[cccmField].length > 0 ? (
                                    item[cccmField].map((cert, certIdx) => (
                                        <div key={cert.idCccm} className={`d-flex justify-content-between align-items-center text-start ${certIdx !== item[cccmField].length - 1 ? 'border-bottom pb-2 mb-2' : ''}`}>
                                            <div className="d-flex flex-column align-items-start" style={{ wordBreak: 'break-word', whiteSpace: 'normal', paddingRight: '10px' }}>
                                                <div className="fw-bold mb-1">
                                                    {cert.loaiCccm && (
                                                        <div className="mb-1">
                                                            <span className="badge bg-success" style={{ fontWeight: '500', padding: '4px 8px', letterSpacing: '0.3px' }}>
                                                                {getShortLoaiChungChi(cert.loaiCccm)}
                                                            </span>
                                                        </div>
                                                    )}
                                                    {cert.fileUrl ? (
                                                        <span onClick={(e) => handleViewFile(cert.fileUrl, e)} title="Click để xem file" className="text-primary text-decoration-underline file-link" style={{ cursor: 'pointer' }}>
                                                            {cert.tenCccm} <i className="fas fa-external-link-alt ms-1" style={{ fontSize: '0.8em' }}></i>
                                                        </span>
                                                    ) : (
                                                        <span className="text-dark">{cert.tenCccm}</span>
                                                    )}
                                                </div>
                                                {cert.ghiChu && (
                                                    <div className="text-muted fw-normal mt-1" style={{ fontSize: '12.5px', fontStyle: 'italic', display: 'block' }}>
                                                        ({cert.ghiChu})
                                                    </div>
                                                )}
                                            </div>
                                            <div className="d-flex align-items-center ms-2 flex-shrink-0" style={{ gap: '4px' }}>
                                                {permissions.readOnlyCccm ? (
                                                    <div>{renderStatusBadge(cert.status, 'duyet')}</div>
                                                ) : (
                                                    <>
                                                        <Button size="sm" variant={cert.status === true ? 'success' : 'outline-success'} onClick={() => openConfirmModal('CCCM', item.id, cert.idCccm, true)} title="Duyệt" className="btn-icon">
                                                            <i className="fas fa-check"></i>
                                                        </Button>
                                                        <Button size="sm" variant={cert.status === false ? 'danger' : 'outline-danger'} onClick={() => openConfirmModal('CCCM', item.id, cert.idCccm, false)} title="Từ chối" className="btn-icon">
                                                            <i className="fas fa-times"></i>
                                                        </Button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-muted fst-italic" style={{ fontSize: '13px' }}>Không có chứng chỉ loại này</div>
                                )}
                            </td>

                            <td className="align-middle text-center">
                                {permissions.readOnlyHoSo ? (
                                    <div>{renderStatusBadge(item.xacNhanStatus, 'hoso')}</div>
                                ) : (
                                    <div className="d-flex align-items-center justify-content-center" style={{ gap: '4px' }}>
                                        <Button size="sm" variant={item.xacNhanStatus === true ? "success" : "outline-success"} onClick={() => setHoSoModal({ show: true, itemId: item.id, status: true, reason: '' })} title="Xác nhận Phù hợp" className="btn-icon">
                                            <i className="fas fa-check"></i>
                                        </Button>
                                        <Button size="sm" variant={item.xacNhanStatus === false ? "danger" : "outline-danger"} onClick={() => setRejectModal({ show: true, itemId: item.id, reason: '', customReason: '' })} title="Xác nhận Không phù hợp" className="btn-icon">
                                            <i className="fas fa-times"></i>
                                        </Button>
                                    </div>
                                )}
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr><td colSpan="8" className="text-center py-4 text-muted">Không tìm thấy dữ liệu phù hợp với bộ lọc</td></tr>
                )}
            </tbody>
        </Table>
    );

    const renderThongKe = () => {
        let total = filteredDanhSach.length;
        let xacNhanPhuHop = 0;
        let xacNhanKhongPhuHop = 0;
        let chuaXacNhan = 0;

        const donViCount = {};
        const doiTuongCount = {};

        filteredDanhSach.forEach(item => {
            if (item.xacNhanStatus === true) xacNhanPhuHop++;
            else if (item.xacNhanStatus === false) xacNhanKhongPhuHop++;
            else chuaXacNhan++;

            const donVi = item.donVi || "Không rõ";
            donViCount[donVi] = (donViCount[donVi] || 0) + 1;

            const doiTuong = item.doiTuong || "Không rõ";
            doiTuongCount[doiTuong] = (doiTuongCount[doiTuong] || 0) + 1;
        });

        const donViArray = Object.entries(donViCount).sort((a, b) => b[1] - a[1]);
        const doiTuongArray = Object.entries(doiTuongCount).sort((a, b) => b[1] - a[1]);

        return (
            <div className="p-4 bg-light rounded">
                <h5 className="text-primary fw-bold mb-4 border-bottom pb-2">Báo cáo thống kê tổng quan</h5>
                <div className="row mb-4">
                    <div className="col-md-3 mb-3 mb-md-0">
                        <Card className="shadow-sm border-primary h-100">
                            <Card.Body className="text-center d-flex flex-column justify-content-center">
                                <h6 className="text-muted mb-2">Tổng số hồ sơ (đang lọc)</h6>
                                <h2 className="text-primary fw-bold mb-0">{total}</h2>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="col-md-3 mb-3 mb-md-0">
                        <Card className="shadow-sm border-success h-100">
                            <Card.Body className="text-center d-flex flex-column justify-content-center">
                                <h6 className="text-muted mb-2">Đã xác nhận Phù hợp</h6>
                                <h2 className="text-success fw-bold mb-0">{xacNhanPhuHop}</h2>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="col-md-3 mb-3 mb-md-0">
                        <Card className="shadow-sm border-danger h-100">
                            <Card.Body className="text-center d-flex flex-column justify-content-center">
                                <h6 className="text-muted mb-2">Xác nhận Không phù hợp</h6>
                                <h2 className="text-danger fw-bold mb-0">{xacNhanKhongPhuHop}</h2>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="col-md-3">
                        <Card className="shadow-sm border-warning h-100">
                            <Card.Body className="text-center d-flex flex-column justify-content-center">
                                <h6 className="text-muted mb-2">Chưa xác nhận</h6>
                                <h2 className="text-warning fw-bold mb-0">{chuaXacNhan}</h2>
                            </Card.Body>
                        </Card>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 mb-3 mb-md-0">
                        <Card className="shadow-sm h-100">
                            <Card.Header className="bg-white fw-bold">Phân bổ theo Đơn vị</Card.Header>
                            <Card.Body className="p-0">
                                <Table hover borderless className="mb-0">
                                    <thead className="bg-light text-muted">
                                        <tr>
                                            <th>Tên đơn vị</th>
                                            <th className="text-center">Số lượng</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {donViArray.length > 0 ? donViArray.map(([name, count], idx) => (
                                            <tr key={idx} className="border-bottom">
                                                <td>{name}</td>
                                                <td className="text-center fw-bold text-primary">{count}</td>
                                            </tr>
                                        )) : <tr><td colSpan="2" className="text-center text-muted py-3">Không có dữ liệu</td></tr>}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </div>

                    <div className="col-md-6">
                        <Card className="shadow-sm h-100">
                            <Card.Header className="bg-white fw-bold">Phân bổ theo Chức danh / Đối tượng</Card.Header>
                            <Card.Body className="p-0">
                                <Table hover borderless className="mb-0">
                                    <thead className="bg-light text-muted">
                                        <tr>
                                            <th>Chức danh</th>
                                            <th className="text-center">Số lượng</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {doiTuongArray.length > 0 ? doiTuongArray.map(([name, count], idx) => (
                                            <tr key={idx} className="border-bottom">
                                                <td>{name}</td>
                                                <td className="text-center fw-bold text-success">{count}</td>
                                            </tr>
                                        )) : <tr><td colSpan="2" className="text-center text-muted py-3">Không có dữ liệu</td></tr>}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </div>
        );
    };

    const renderThongKeHLDT = () => {
        const stats = {};
        let totalCccmHLDT = 0;

        filteredDanhSach.forEach(item => {
            const doiTuong = item.doiTuong || "Không rõ";

            if (!stats[doiTuong]) {
                stats[doiTuong] = { total: 0, details: {} };
            }

            if (item.cccmHLDT && item.cccmHLDT.length > 0) {
                item.cccmHLDT.forEach(cert => {
                    const certName = cert.tenCccm || "Chưa rõ tên CC";
                    stats[doiTuong].details[certName] = (stats[doiTuong].details[certName] || 0) + 1;
                    stats[doiTuong].total += 1;
                    totalCccmHLDT += 1;
                });
            }
        });

        const statsArray = Object.entries(stats).sort((a, b) => b[1].total - a[1].total);

        return (
            <div className="p-4 bg-light rounded">
                <div className="d-flex justify-content-between align-items-end mb-4 border-bottom pb-2">
                    <h5 className="text-primary fw-bold mb-0">Thống kê số lượng Văn bằng / Chứng chỉ HLDT</h5>
                    <span className="badge bg-primary fs-6">Tổng cộng: {totalCccmHLDT} chứng chỉ</span>
                </div>

                <Card className="shadow-sm mb-5">
                    <Card.Body className="p-0">
                        <Table hover bordered responsive className="mb-0 text-center">
                            <thead className="bg-light text-muted align-middle">
                                <tr>
                                    <th style={{ width: '30%' }}>Đối tượng (Chức danh)</th>
                                    <th>Loại Văn bằng / Chứng chỉ</th>
                                    <th style={{ width: '20%' }}>Số lượng</th>
                                </tr>
                            </thead>
                            <tbody>
                                {statsArray.length > 0 ? statsArray.map(([doiTuong, data], idx) => {
                                    const certEntries = Object.entries(data.details).sort((a, b) => b[1] - a[1]);

                                    if (certEntries.length === 0) {
                                        return (
                                            <tr key={idx} className="align-middle">
                                                <td className="text-start fw-bold text-dark">{doiTuong}</td>
                                                <td className="text-muted fst-italic">Không ghi nhận chứng chỉ</td>
                                                <td className="text-muted">0</td>
                                            </tr>
                                        );
                                    }

                                    return certEntries.map(([certName, count], certIdx) => (
                                        <tr key={`${idx}-${certIdx}`} className="align-middle">
                                            {certIdx === 0 && (
                                                <td rowSpan={certEntries.length} className="text-start fw-bold text-dark border-end align-middle">
                                                    {doiTuong}
                                                    <div className="text-muted fw-normal mt-1" style={{ fontSize: '12px' }}>
                                                        (Tổng: {data.total})
                                                    </div>
                                                </td>
                                            )}
                                            <td className="text-start">{certName}</td>
                                            <td className="fw-bold text-primary">{count}</td>
                                        </tr>
                                    ));
                                }) : (
                                    <tr><td colSpan="3" className="text-center py-4 text-muted">Không có dữ liệu thống kê</td></tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>

                <div className="d-flex justify-content-between align-items-end mb-4 border-bottom pb-2">
                    <h5 className="text-primary fw-bold mb-0">Danh sách chi tiết (Chỉ hiển thị chứng chỉ đã duyệt)</h5>
                </div>

                <Card className="shadow-sm border-0">
                    <Card.Body className="p-0">
                        <Table responsive hover bordered striped className="mb-0 text-center">
                            <thead className="bg-light">
                                <tr className="align-middle">
                                    <th>STT</th>
                                    <th>Họ tên</th>
                                    <th>Chức danh</th>
                                    <th>Đơn vị</th>
                                    <th style={{ minWidth: '300px' }}>Phạm vi hành nghề</th>
                                    <th style={{ minWidth: '300px' }}>Chứng chỉ hành nghề</th>
                                    <th style={{ minWidth: '350px' }}>Chứng chỉ chuyên môn</th>
                                    <th style={{ minWidth: '140px' }}>Xác nhận hồ sơ</th>
                                    <th style={{ minWidth: '180px' }}>Xác nhận gửi cục Quân Y</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 ? (
                                    currentItems.map((item, index) => {
                                        const approvedCerts = (item.cccmHLDT || []).filter(cert => cert.status === true);

                                        return (
                                            <tr key={item.id} className="align-middle">
                                                <td className="align-middle text-center">{indexOfFirstItem + index + 1}</td>
                                                <td className="text-start fw-bold align-middle">{item.ten}</td>
                                                <td className="align-middle">{item.doiTuong}</td>
                                                <td className="align-middle">{item.donVi}</td>

                                                <td className="text-start align-middle">
                                                    {item.phamViHanhNghe && item.phamViHanhNghe.length > 0 ? (
                                                        item.phamViHanhNghe.map((pv, idx) => (
                                                            <div key={idx}>{pv}</div>
                                                        ))
                                                    ) : (
                                                        <span className="text-muted fst-italic">-</span>
                                                    )}
                                                </td>

                                                <td className="align-middle">
                                                    <div className="d-flex justify-content-between align-items-center text-start">
                                                        <div>
                                                            <div className="fw-bold mb-1">
                                                                {item.fileUrl ? (
                                                                    <span onClick={(e) => handleViewFile(item.fileUrl, e)} title="Click để xem file" className="text-primary text-decoration-underline file-link" style={{ cursor: 'pointer' }}>
                                                                        {item.cchn} <i className="fas fa-external-link-alt ms-1" style={{ fontSize: '0.8em' }}></i>
                                                                    </span>
                                                                ) : (
                                                                    <span className="text-dark">{item.cchn}</span>
                                                                )}
                                                            </div>
                                                            <div className="text-muted" style={{ fontSize: '12px' }}>
                                                                {item.moTaCchn?.map((line, idx) => <div key={idx}>{line}</div>)}
                                                            </div>
                                                        </div>
                                                        <div className="d-flex flex-column align-items-end ms-2 flex-shrink-0">
                                                            {renderStatusBadge(item.cchnStatus, 'duyet')}
                                                        </div>
                                                    </div>
                                                </td>

                                                <td className="align-middle">
                                                    {approvedCerts.length > 0 ? (
                                                        approvedCerts.map((cert, certIdx) => (
                                                            <div key={cert.idCccm} className={`d-flex justify-content-between align-items-center text-start ${certIdx !== approvedCerts.length - 1 ? 'border-bottom pb-2 mb-2' : ''}`}>
                                                                <div className="d-flex flex-column align-items-start" style={{ wordBreak: 'break-word', whiteSpace: 'normal', paddingRight: '10px' }}>
                                                                    <div className="fw-bold mb-1">
                                                                        {cert.loaiCccm && (
                                                                            <div className="mb-1">
                                                                                <span className="badge bg-success" style={{ fontWeight: '500', padding: '4px 8px', letterSpacing: '0.3px' }}>
                                                                                    {getShortLoaiChungChi(cert.loaiCccm)}
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                        {cert.fileUrl ? (
                                                                            <span onClick={(e) => handleViewFile(cert.fileUrl, e)} title="Click để xem file" className="text-primary text-decoration-underline file-link" style={{ cursor: 'pointer' }}>
                                                                                {cert.tenCccm} <i className="fas fa-external-link-alt ms-1" style={{ fontSize: '0.8em' }}></i>
                                                                            </span>
                                                                        ) : (
                                                                            <span className="text-dark">{cert.tenCccm}</span>
                                                                        )}
                                                                    </div>
                                                                    {cert.ghiChu && (
                                                                        <div className="text-muted fw-normal mt-1" style={{ fontSize: '12.5px', fontStyle: 'italic', display: 'block' }}>
                                                                            ({cert.ghiChu})
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="d-flex flex-column align-items-end ms-2 flex-shrink-0">
                                                                    {renderStatusBadge(true, 'duyet')}
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="text-muted fst-italic" style={{ fontSize: '13px' }}>Không có chứng chỉ nào đã duyệt</div>
                                                    )}
                                                </td>

                                                <td className="align-middle text-center">
                                                    {renderStatusBadge(item.xacNhanStatus, 'hoso')}
                                                </td>

                                                <td className="align-middle text-center">
                                                    <Button
                                                        size="sm"
                                                        variant="primary"
                                                        className="fw-medium text-nowrap"
                                                        onClick={() => toast.success(`Đã xác nhận gửi hồ sơ của ${item.ten} lên cục Quân Y!`)}
                                                    >
                                                        <i className="fas fa-paper-plane me-1"></i> Xác nhận gửi
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr><td colSpan="9" className="text-center py-4 text-muted">Không tìm thấy dữ liệu phù hợp với bộ lọc</td></tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>
        );
    };

    return (
        <>
            <style>
                {`
                    .modal-backdrop.show { z-index: 1040 !important; }
                    .modal.show { z-index: 1055 !important; }
                    .file-link:hover { opacity: 0.8; }

                    .custom-tabs-container { width: 100%; margin-top: 1rem; }
                    .custom-tab-headers { display: flex; border-bottom: 2px solid #e2e8f0; margin: 0; padding: 0; }
                    .custom-tab-btn {
                        font-family: 'Inter', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
                        background: #f8fafc; border: 1px solid transparent; border-top-left-radius: 8px; border-top-right-radius: 8px;
                        padding: 12px 24px; font-size: 15px; font-weight: 500; color: #64748b; cursor: pointer;
                        margin-right: 4px; margin-bottom: -2px; transition: all 0.2s ease-in-out;
                    }
                    .custom-tab-btn:hover:not(.active) { background: #e2e8f0; color: #334155; }
                    .custom-tab-btn.active {
                        background: #ffffff; color: #0d6efd; font-weight: 600; border-color: #e2e8f0; border-bottom-color: #ffffff; 
                    }
                    .custom-tab-content {
                        background: #ffffff; border: 1px solid #e2e8f0; border-top: none; 
                        border-bottom-left-radius: 8px; border-bottom-right-radius: 8px; padding: 20px 0; width: 100%;
                    }
                    .custom-tab-content.is-thongke { padding: 0; border: 1px solid transparent; }
                    
                    .btn-icon {
                        width: 32px;
                        height: 32px;
                        padding: 0;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    }
                `}
            </style>

            <div className="container-fluid mt-3">
                <Card>
                    <Card.Header>
                        <h5 className="mb-0">Danh sách duyệt hồ sơ y tế</h5>
                    </Card.Header>
                    <Card.Body className="p-3">

                        <div className="d-flex flex-wrap justify-content-between align-items-end mb-3" style={{ gap: '15px' }}>
                            <div className="d-flex flex-column">
                                <span className="text-muted fw-medium mb-1" style={{ fontSize: '13px' }}>Hiển thị dòng:</span>
                                <Form.Control as="select" size="sm" value={itemsPerPage} onChange={handleItemsPerPageChange} style={{ minWidth: '80px', cursor: 'pointer' }} disabled={activeTab === 'thongke'}>
                                    <option value={5}>5 dòng</option>
                                    <option value={10}>10 dòng</option>
                                    <option value={20}>20 dòng</option>
                                    <option value={50}>50 dòng</option>
                                    <option value={999999}>Tất cả</option>
                                </Form.Control>
                            </div>
                            <div className="d-flex flex-wrap align-items-center" style={{ gap: '15px' }}>
                                <div className="d-flex flex-column">
                                    <span className="text-muted fw-medium mb-1" style={{ fontSize: '13px' }}>Đơn vị:</span>
                                    <Form.Control as="select" size="sm" value={filterDonVi} onChange={handleFilterDonViChange} style={{ minWidth: '200px', cursor: 'pointer' }}>
                                        <option value="all">-- Tất cả Đơn vị --</option>
                                        {uniqueDonVi.map(dv => <option key={dv} value={dv}>{dv}</option>)}
                                    </Form.Control>
                                </div>
                                <div className="d-flex flex-column">
                                    <span className="text-muted fw-medium mb-1" style={{ fontSize: '13px' }}>Đối tượng:</span>
                                    <Form.Control as="select" size="sm" value={filterDoiTuong} onChange={handleFilterDoiTuongChange} style={{ minWidth: '180px', cursor: 'pointer' }}>
                                        <option value="all">-- Tất cả Đối tượng --</option>
                                        {uniqueDoiTuong.map(dt => <option key={dt} value={dt}>{dt}</option>)}
                                    </Form.Control>
                                </div>
                                <div className="d-flex flex-column">
                                    <span className="text-muted fw-medium mb-1" style={{ fontSize: '13px' }}>Trạng thái xác nhận:</span>
                                    <Form.Control as="select" size="sm" value={filterXacNhan} onChange={handleFilterXacNhanChange} style={{ minWidth: '150px', cursor: 'pointer' }}>
                                        <option value="all">-- Tất cả --</option>
                                        <option value="phu_hop">Phù hợp</option>
                                        <option value="khong_phu_hop">Không phù hợp</option>
                                        <option value="chua_xac_nhan">Chưa xác nhận</option>
                                    </Form.Control>
                                </div>
                            </div>
                        </div>

                        <div className="custom-tabs-container">
                            <div className="custom-tab-headers">
                                {canViewHLDT && (
                                    <>
                                        <button className={`custom-tab-btn ${activeTab === 'thongke-hldt' ? 'active' : ''}`} onClick={() => setActiveTab('thongke-hldt')}><i className="fas fa-list-alt me-1"></i> Thống kê HLDT</button>
                                        <button className={`custom-tab-btn ${activeTab === 'hldt' ? 'active' : ''}`} onClick={() => setActiveTab('hldt')}>HLĐT</button>
                                    </>
                                )}
                                {canViewKHTH && (
                                    <>
                                        <button className={`custom-tab-btn ${activeTab === 'thongke' ? 'active' : ''}`} onClick={() => setActiveTab('thongke')}><i className="fas fa-chart-pie me-1"></i> Tổng quan</button>
                                        <button className={`custom-tab-btn ${activeTab === 'khth' ? 'active' : ''}`} onClick={() => setActiveTab('khth')}>KHTH</button>
                                    </>
                                )}
                            </div>

                            <div className={`custom-tab-content ${activeTab === 'thongke' ? 'is-thongke' : ''}`}>
                                {canViewHLDT && activeTab === 'thongke-hldt' && renderThongKeHLDT()}
                                {canViewHLDT && activeTab === 'hldt' && renderTable('cccmHLDT', { readOnlyCchn: false, readOnlyCccm: false, readOnlyHoSo: true })}

                                {canViewKHTH && activeTab === 'thongke' && renderThongKe()}
                                {canViewKHTH && activeTab === 'khth' && renderTable('cccmKHTH', { readOnlyCchn: true, readOnlyCccm: true, readOnlyHoSo: false })}
                            </div>
                        </div>

                        {filteredDanhSach.length > 0 && activeTab !== 'thongke' && (
                            <div className="d-flex flex-wrap justify-content-between align-items-center mt-3 p-2 bg-light rounded border border-top-0" style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                                <div className="text-muted fw-medium" style={{ fontSize: '14px' }}>
                                    Hiển thị từ <span className="text-dark fw-bold">{indexOfFirstItem + 1}</span> đến <span className="text-dark fw-bold">{Math.min(indexOfLastItem, totalRecords)}</span> trong tổng số <span className="text-primary fw-bold">{totalRecords}</span> hồ sơ
                                </div>
                                {totalPages > 1 && (
                                    <Pagination size="sm" className="mb-0 mt-2 mt-md-0">
                                        <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                                        {[...Array(totalPages)].map((_, index) => (
                                            <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => paginate(index + 1)}>{index + 1}</Pagination.Item>
                                        ))}
                                        <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
                                    </Pagination>
                                )}
                            </div>
                        )}
                    </Card.Body>
                </Card>
            </div>

            <Modal show={rejectModal.show} onHide={() => setRejectModal({ show: false, itemId: null, reason: '', customReason: '' })} centered backdrop="static">
                <Modal.Header closeButton className="border-bottom-0 pb-0">
                    <Modal.Title className="fs-5 fw-bold text-danger"><i className="fas fa-exclamation-triangle me-2"></i> Lý do không phù hợp</Modal.Title>
                </Modal.Header>
                <Modal.Body className="fs-6 py-4">
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-medium">Chọn lý do <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            as="select"
                            value={rejectModal.reason}
                            onChange={(e) => setRejectModal({ ...rejectModal, reason: e.target.value })}
                            className="form-control"
                        >
                            <option value="">-- Vui lòng chọn lý do --</option>
                            {REJECT_REASONS.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
                        </Form.Control>
                    </Form.Group>

                    {rejectModal.reason === 'Khác' && (
                        <Form.Group className="mb-0 mt-3">
                            <Form.Label className="fw-medium">Nhập lý do khác <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Vui lòng nhập lý do cụ thể..."
                                value={rejectModal.customReason}
                                onChange={(e) => setRejectModal({ ...rejectModal, customReason: e.target.value })}
                            />
                        </Form.Group>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-top-0 pt-0">
                    <Button variant="light" onClick={() => setRejectModal({ show: false, itemId: null, reason: '', customReason: '' })} className="fw-medium px-4 border">Hủy</Button>
                    <Button
                        variant="primary"
                        className="fw-medium px-4"
                        disabled={!rejectModal.reason || (rejectModal.reason === 'Khác' && !rejectModal.customReason.trim())}
                        onClick={() => {
                            const finalReason = rejectModal.reason === 'Khác' ? rejectModal.customReason : rejectModal.reason;
                            setRejectModal({ show: false, itemId: null, reason: '', customReason: '' });
                            setHoSoModal({ show: true, itemId: rejectModal.itemId, status: false, reason: finalReason });
                        }}
                    >
                        Tiếp tục
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={hoSoModal.show} onHide={() => setHoSoModal({ show: false, itemId: null, status: null, reason: '' })} centered backdrop="static">
                <Modal.Header closeButton className="border-bottom-0 pb-0">
                    <Modal.Title className="fs-5 fw-bold text-primary"><i className="fas fa-info-circle me-2 text-info"></i> Xác nhận trạng thái</Modal.Title>
                </Modal.Header>
                <Modal.Body className="fs-6 py-4 text-dark">
                    Bạn có chắc chắn muốn xác nhận toàn bộ hồ sơ này là <strong className={hoSoModal.status ? "text-success" : "text-danger"}>{hoSoModal.status ? 'PHÙ HỢP' : 'KHÔNG PHÙ HỢP'}</strong>?

                    {hoSoModal.status === false && hoSoModal.reason && (
                        <div className="mt-3 p-3 bg-light rounded border">
                            <span className="fw-bold">Lý do:</span> <span className="text-danger fst-italic">{hoSoModal.reason}</span>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-top-0 pt-0">
                    <Button variant="light" onClick={() => setHoSoModal({ show: false, itemId: null, status: null, reason: '' })} className="fw-medium px-4 border">Hủy</Button>
                    <Button variant={hoSoModal.status ? "success" : "danger"} onClick={xacNhanHoSoConfirm} className="fw-medium px-4">Đồng ý</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered backdrop="static" keyboard={false}>
                <Modal.Header closeButton className="border-bottom-0 pb-0">
                    <Modal.Title className="fs-5 fw-bold text-primary"><i className="fas fa-exclamation-circle me-2 text-warning"></i> Xác nhận thao tác</Modal.Title>
                </Modal.Header>
                <Modal.Body className="fs-6 py-4 text-dark">{getConfirmMessage()}</Modal.Body>
                <Modal.Footer className="border-top-0 pt-0">
                    <Button variant="light" onClick={() => setShowConfirmModal(false)} className="fw-medium px-4 border">Hủy</Button>
                    <Button variant={pendingAction && pendingAction.status === false ? "danger" : "primary"} onClick={handleConfirmAction} className="fw-medium px-4">Đồng ý</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DanhSachDuyetHoSo;